/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

/**
 * __Square__
 *
 * Square glyph with animated circle.
 *
 */
export const Square = (): JSX.Element => (
	<svg
		width="100%"
		height="100%"
		viewBox="0 0 597.812 598.135"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<defs>
			<mask id="square-mask">
				<rect x="0" y="0" width="597.812" height="598.135" fill="white" />
				<circle cx="298.919" cy="299.079" r="179.44" fill="black" data-square-circle />
			</mask>
		</defs>
		<path d="M0 598.135V0H597.812V598.135H0Z" fill="currentColor" mask="url(#square-mask)" />
	</svg>
);
